import React from 'react';
import { useWizard } from '../../../../../../../../components/wizard/WizardContext';
import { getCalculatedFeeDetails, mapFeeBreakupTotals } from './utils';
import { getTotalCourseDays } from '../../../../utils';
import CalculationsCard from './CalculationsCard';
import { useSaveDataToConfigValues } from '../../../../../rectificationRefund/selectRefundReasonAndReceipt/utils';

const WithdrwalRefundCalculations = ({ refundDetailsForm, withdrawalRefundPayableInfo }) => {

    const { weekNumber, policyId, associatedRuleIds } = withdrawalRefundPayableInfo;

    const { values } = useWizard();
    const { multiTypeRefundStep2Data } = values;

    const { additionalStudentDetails } = multiTypeRefundStep2Data ?? {};
    const { studentFeeBreakup, coursePricingDetails } = additionalStudentDetails ?? {};

    const totals = mapFeeBreakupTotals(studentFeeBreakup, refundDetailsForm?.refundApplicationDate);

    const calculated = {
        ...getCalculatedFeeDetails(totals, refundDetailsForm, coursePricingDetails),
        weekForRefund: weekNumber,
        policyId,
        associatedRuleIds
    }

    console.log('withdrawalFeeSummary', calculated);

    useSaveDataToConfigValues({ withdrawalFeeSummary: calculated }, "multiTypeRefundStep2Data")

    return (
        <CalculationsCard calculatedData={calculated} />
    );
}

export default WithdrwalRefundCalculations;